import { createSelector } from 'reselect';
import { IPagesHistoryHomeState } from './reducer';

const selectHomeState = (state: any): Readonly<IPagesHistoryHomeState> => {
  return state.pagesHistoryHome;
};

export const getPagesHistoryHomeState = createSelector(
  selectHomeState,
  homeState => {
    return homeState;
  },
);

export const getQuoteMessageId = createSelector(
  selectHomeState,
  homeState => {
    return homeState.quoteMessageId;
  },
);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/selectors.ts